/**
 * File: apps/qbench-cp/reactapp/src/shared/stub/attachments.js
 *
 * Purpose: Provides a mock attachments API for local development/testing when stubs are
 *     enabled.
 *
 * Scope: Frontend API stubs for the customer portal.
 *
 * Tags: customer-portal
 *
 * Overview: Exposes save and get functions that return canned empty responses only when
 *     REACT_APP_STUBS_ENABLED is "true"; otherwise they return a falsy value so the real API
 *     call path is used.
 *
 * Exports: AttachmentStub object.
 */
import { getRuntimeConfig } from 'shared/configs/runtimeConfig';
const RETURN_STUB = getRuntimeConfig().stubsEnabled;

export const AttachmentStub = {
  save: (dataType, attachment) =>
    RETURN_STUB && {
      data: {},
    },
  get: (dataType, params) =>
    RETURN_STUB && {
      data: [],
    },
};
